import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from 'grommet/components/Box'
import Heading from 'grommet/components/Heading'
import Paragraph from 'grommet/components/Paragraph'

import Footer from '../components/Footer'
import Header from '../components/Header'
import IElement from '../components/InteractiveElement'

import '../styles/InteractiveElement.css'

class InteractiveElement extends Component {
  render () {
    const {
      title,
      subtitle
    } = this.props.data

    return (
      <div className='InteractiveElement'>
        <Header bg='primary-1' />

        <Box align='center'>
          <Heading align='center' margin='none'>{title}</Heading>
          <Paragraph align='center' size='large'>{subtitle}</Paragraph>
          <div className='frame'>
            <IElement data={this.props.data} history={this.props.history} />
          </div>
        </Box>

        <Footer
          isRoot={this.props.isRoot}
          history={this.props.history} />
      </div>
    )
  }
}

InteractiveElement.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default InteractiveElement



// WEBPACK FOOTER //
// ./src/layouts/InteractiveElement.js